module.exports = __webpack_public_path__ + "img/24.4b85a784.png";